import React from 'react';
import './resultsPageCompo.scss';

const ScoreComponent = ({ title, score, color}) => {
    return(
        <div className='d-flex 
        flex-lg-row 
        flex-column 
        justify-content-lg-between 
        justify-content-center
        align-items-center ml-4 mr-4 px-4 align-self-center' style={{
            width: '25%',
            height: 80,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            }}>
            <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column'}}>
              <p className='h3' style={{color: color}}>{score}</p>
              <p style={{color: color, fontSize: 18, textAlign: 'justify', }}>{title}</p>
            </div>
            <div style={{width: 2, height: 80, background: '#DFE7F5'}}>
  
            </div>
        </div>
    )
  }
  
 const ExamDetailsComponent = ({className, examDate,  time, timeValue,  duration,  totalMarks}) => {
      return(
          <div className={className}>
              <div className='mx-lg-4 mx-0 my-lg-4 my-0'>
                  <p className='h5'>Exam Details</p>
                  <div className='info py-2'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Exam Date: </span>
                     <span className='ml-2' style={{color: '#000', fontSize: 18}}>{examDate || '1/01/2020'}</span>
                  </div>
                  <div className='info py-2'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Exam Time: </span>
                     <span className='ml-2' style={{color: '#000', fontSize: 18}}>{time || "09.00am"}</span>
                  </div>
                  <div className='info py-2'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Total Marks: </span>
                     <span className='ml-2' style={{color: '#000', fontSize: 18}}>{totalMarks || '100'}</span>
                  </div>
                  <div className='info py-2'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Duration: </span>
                     <span className='ml-2' style={{color: '#000', fontSize: 18}}>{ duration || '90 min'}</span>
                  </div>
              </div>
          </div>
      )
  }
 const SubjectDetails = ({className, examName, subject, time, timeValue,  duration, }) => {
      return(
          <div className={className}>
              <div className='mx-lg-4 mx-0 my-lg-4 my-0'>
                  <p className='  h5 '>Subjects</p>
                  <div className='strip py-2' style={{

                  }}>
                     <p className='h5' style={{textAlign: 'center'}}>{subject} </p>
                  </div>
                  <div className='py-2' style={{

                  }}>
                      <p className='h5'>Topic Covered</p>
                  </div>
                  <div className='info py-1'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Topic 1</span>
                     {/* <span className='ml-2' style={{color: '#000', fontSize: 18}}>{time || "09.00am"}</span> */}
                  </div>
                  <div className='info py-1'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Topic 2 </span>
                  </div>
                  <div className='info py-1'>
                     <span style={{color: '#8794B8', fontSize: 18}}>Topic 3</span>
                  </div>
              </div>
          </div>
      )
  }


  export {
    ScoreComponent,
    ExamDetailsComponent,
    SubjectDetails
  }